import { funIdAuthDataMock } from '../constants/funid-auth-data-mock';
const transformMedia = (response) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        alt: ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.alternativeText) || '',
        ext: ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.ext) || '',
        mime: ((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.mime) || '',
        url: ((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.attributes) === null || _h === void 0 ? void 0 : _h.url) || '',
    });
};
const mapResponse = ({ data: { attributes }, }) => ({
    title: attributes.title,
    description: attributes.description,
    text: attributes.text,
    infoButtonText: attributes.infoButtonText,
    background: transformMedia(attributes.background),
    logo: transformMedia(attributes.logo),
    info: {
        title: attributes.info.title,
        button: attributes.info.button,
        guide: attributes.info.guide.map(infoItem => ({
            title: infoItem.title,
            description: infoItem.description,
            media: transformMedia(infoItem.media),
        })),
    },
    steps: {
        title: attributes.steps.title,
        items: attributes.steps.items.map(stepItem => ({
            text: stepItem.text,
            link: stepItem.link,
            icon: transformMedia(stepItem.icon),
        })),
    },
    downloads: {
        title: attributes.downloads.title,
        items: attributes.downloads.items.map(downloadItem => ({
            text: downloadItem.text,
            link: downloadItem.link,
            icon: transformMedia(downloadItem.icon),
        })),
    },
});
export class FunIdAuthService {
    static getWidget(apiUrl, lang = 'en') {
        return fetch(`${apiUrl}/auth-widget?populate=steps,steps.items,steps.items.icon,downloads,downloads.items,downloads.items.icon,info,info.guide,info.guide.media,background,logo&locale=${lang}`)
            .then((res) => res.json())
            .then(mapResponse)
            .catch(() => mapResponse(funIdAuthDataMock));
    }
    static getAvailableLangs(apiUrl) {
        return fetch(`${apiUrl}/auth-widget?populate[localizations][fields]=locale&fields=locale`)
            .then(res => res.json())
            .then((response) => {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.localizations) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.map(data => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.attributes) === null || _a === void 0 ? void 0 : _a.locale; });
        });
    }
}
//# sourceMappingURL=funid-auth-service.js.map